<script>
    import {_} from '../lib/i18n';
    import {Constans} from "../lib/Constants";
    export let instagramLink;
    export let show = false;
    export let type = Constans.typeHeaders.POST;
    export let videoUrl;

    export let videoCreatedAt;

    function closeModal() {
        paused = true;
        show = false;
    }

    let time;
    let duration;
    let paused;
</script>

<section class={`modal ${show ? '' : 'hide'}`}>
    <div class="modal__fade" on:click={closeModal}></div>
    <div class="modal-body modal-body_media modal-body_video">
        <div data-modal-event="close" class="modal-body__close-icon" on:click={closeModal}>
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.06665 7.4668L15.5333 14.9335" stroke="#C6C5D2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.5333 7.4668L8.06666 14.9335" stroke="#C6C5D2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
        <div class="modal-body__header">
            <h4 class="modal-body__header-title">{$_('viewVideoModal.' + type)}</h4>
            {#if videoCreatedAt}
                <p class="modal-body__header-subtitle">{$_('viewVideoModal.publishDateLabel')}: {videoCreatedAt.toLocaleString()}</p>
            {/if}
        </div>
        <div class="modal-body__content-wrapper">
            <div class="modal-body__content-item">
                <video src={videoUrl}
                       controls
                       playsinline
                       class="modal-body__content-video"
                       bind:currentTime={time}
                       bind:duration
                       bind:paused
                >

                </video>
            </div>
        </div>
        <div class="modal-body__controls-wrapper">
            <button data-modal-event="close" class="button button_shadow modal-body__btn-main" on:click={closeModal}>
                {$_('viewVideoModal.closeLabel')}
            </button>
            {#if instagramLink}
            <a href="{instagramLink}" class="button button_icon-text button_textual modal-body__btn-secondary" target="_blank">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.75 4.25H5.75C4.92157 4.25 4.25 4.92157 4.25 5.75V13.25C4.25 14.0784 4.92157 14.75 5.75 14.75H13.25C14.0784 14.75 14.75 14.0784 14.75 13.25V9.6875M14.75 4.25H11.75M14.75 4.25V7.25M14.75 4.25L7.25 11.75" stroke="#84B43C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {$_('viewVideoModal.viewInInstagram')}
            </a>
            {/if}
        </div>
    </div>
</section>

<style>
    section.modal {
        margin-left: 0;
        margin-right: 0;
    }
    .hide {
        display: none;
    }
    .modal-body {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>